import dayjs from "dayjs";
import "dayjs/locale/fr";
import React from "react";

export default function ReglementExpand({ fournisseur, selectedMonths }) {
    dayjs.locale("fr");

    // If the fournisseur has no months at all
    if (!fournisseur.months || fournisseur.months.length === 0) {
        return (
            <tr className="reglement-expand-wrapper">
                <td></td>
                <td colSpan={6}>
                    <div className="reglement-expand-content">
                        <em>Aucun mois disponible pour ce fournisseur.</em>
                    </div>
                </td>
            </tr>
        );
    }

    const columnWidth = 150;

    const filteredMonths =
        Array.isArray(selectedMonths) && selectedMonths.length > 0
            ? fournisseur.months.filter(m => selectedMonths.includes(m.mois.split("-")[1])
            )
            : fournisseur.months || [];

    return (
        <tr className="reglement-expand-wrapper">
            <td className="id-datacell"></td>
            <td colSpan={6}>
                <div className="reglement-expand-content expand-content" >
                    <div className="reglement-mini-table-container">
                        <table className="reglement-mini-table">
                            <colgroup>
                                {filteredMonths.map((month) => (
                                    <>
                                        <col key={`factures-col-${month.id}`} style={{ width: `${columnWidth}px` }} />
                                        <col key={`reglements-col-${month.id}`} style={{ width: `${columnWidth}px` }} />
                                        <col key={`estimation-col-${month.id}`} style={{ width: `${columnWidth}px` }} />
                                    </>
                                ))}
                            </colgroup>
                            <thead>
                                <tr className="mini-table-header">
                                    {filteredMonths.map((month) => (
                                        <th key={month.id} colSpan={3}>
                                            {dayjs(month.mois, "YYYY-MM").format("MMMM")}
                                        </th>
                                    ))}
                                </tr>
                                <tr className="mini-table-header">
                                    {filteredMonths.map((month) => (
                                        <React.Fragment key={month.mois}>
                                            <th>Total Factures</th>
                                            <th>Total Réglements</th>
                                            <th>Total Estimation</th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="mini-table-row">
                                    {filteredMonths.map((month) => (
                                        <React.Fragment key={`row-${month.mois}`}>
                                            <td>{month.total_mntdt.toFixed(2)} TND</td>
                                            <td>{month.total_reglement.toFixed(2)} TND</td>
                                            <td>{month.total_estimation?.toFixed(2) ?? 0} TND</td>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </td>
        </tr>
    );
}
